/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import 'wever-maps/src/assets/style.scss';

import View from '@/components/view';
import Context from '@/services/context';
import getResource from '@/services/resources';

import AccordionItem from './accordion-item';

export default () => {
  const { community } = useContext(Context);
  const [communities, setCommunities] = useState(null);
  const refCard = useRef();

  const loadMapCommunities = async () => {
    const list = await getResource('Community').managedList(true, community, false);

    setCommunities(list);
  };

  useEffect(() => {
    loadMapCommunities();
  }, [community]);

  return (
    <View>
      <Card style={{ height: '100%' }} ref={refCard}>
        <CardBody style={{ position: 'relative', overflow: 'auto', padding: 0 }}>
          {communities &&
            communities.map((communityMapped) => (
              <AccordionItem community={communityMapped} key={communityMapped.id} />
            ))}
        </CardBody>
      </Card>
    </View>
  );
};
